import { Title } from '../styled-components'

const TitleV2 = ({ hidden, text }) => {
  if (hidden) {
    return null
  }
  return (
    <Title>
      <div dangerouslySetInnerHTML={{ __html: text }} />
    </Title>
  )
}

export default TitleV2
